import { ApolloClient, InMemoryCache, split } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';
import { createHttpLink } from './http/httpLink';
import { createWebsocketLink } from './ws/websocketLink';

const httpUrl = process.env.REACT_APP_AWS_APPSYNC_GRAPHQL_ENDPOINT || '';
const httpHost = httpUrl.replace('https://', '').replace('/graphql', '');
const wsUrl = httpUrl
  .replace('https', 'wss')
  .replace('appsync-api', 'appsync-realtime-api');

const httpLink = createHttpLink(httpUrl);
const wsLink = createWebsocketLink(wsUrl, httpHost);

const apolloLink = split(
  (operation) => {
    // Using this logic, queries and mutations will use HTTP as normal, and subscriptions will use WebSocket.
    const { query } = operation;
    const { kind, operation: graphqlOperation } = getMainDefinition(query);
    const isSubscription =
      kind === 'OperationDefinition' && graphqlOperation === 'subscription';

    return isSubscription;
  },
  wsLink,
  httpLink
);

export const client = new ApolloClient({
  link: apolloLink,
  cache: new InMemoryCache(),
  defaultOptions: {
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all'
    }
  }
});
